module.exports = "<slot _v-55faf3cb=\"\"></slot>";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-55faf3cb&file=TabGroup.vue!./~/vue-loader/lib/selector.js?type=template&index=0!./src/TabGroup.vue
 ** module id = 212
 ** module chunks = 0
 **/